import type { CreateTrailerInput } from '@chukua/common';
import { useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { createTrailer } from '../trailers.api';
import { useTrailerList } from './use-trailer-list';

/** The trailers list (`useTrailerList`) plus create — a form failure stays inline (CLAUDE.md → Web conventions). */
export function useTrailers() {
  const { state, list, isRefreshing, reload } = useTrailerList();
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself — same shape as useCustomers.create. */
  async function create(input: CreateTrailerInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      await createTrailer(input);
      await reload();
      toast.success(`${input.registration} created`);
      return true;
    } catch (err) {
      setCreateError(
        err instanceof ApiError && err.status === 409
          ? 'A trailer with this registration already exists.'
          : 'Could not create the trailer — check the fields and try again.',
      );
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { state, list, isRefreshing, createError, creating, create, resetCreateError: () => setCreateError(null) };
}
